export default "__VITE_ASSET__DgaTKiyE__"